// Activity types in range 1000-1099 are APQ
export enum ActivityType {
  PublicEnqiryCreateNote = 2000,
  PublicEnquiryClosed = 2001,
  PublicEnquiryReOpened = 2002,
  PublicEnquiryAssigned = 2003,
  PublicEnquiryUnAssigned = 2004,
  PublicEnquiryInternalMessage = 2005,
  PublicEnquiryPublicMessage = 2010,
  FoiCreatedFromPublicEnquiry =3007
}
